module.exports = __webpack_public_path__ + "media/applicants/device_signup_6-fc997c27.jpg";